import * as React from 'react';
import { Button, Typography } from '@/components/common';

interface ActionRequiredOnboardingItemsProps {
	showVerifyIdentityAction: boolean;
	showTakeTheTourAction: boolean;
	onVerifyIdentity: () => void;
	onTakeTheTour: () => void;
}

export const ActionRequiredOnboardingItems: React.FC<
	ActionRequiredOnboardingItemsProps
> = ({
	showVerifyIdentityAction,
	showTakeTheTourAction,
	onVerifyIdentity,
	onTakeTheTour,
}) => (
	<>
		{showVerifyIdentityAction && (
			<li className="flex flex-col w-full gap-1 p-2 bg-grey-2 rounded-2xl">
				<Button
					label="Verify Your Identity"
					decoration="line-primary"
					size="fit"
					className="!py-1 !w-fit"
					onClick={onVerifyIdentity}
				/>
			</li>
		)}
		{showTakeTheTourAction && (
			<li className="flex flex-col w-full gap-1 p-2 bg-grey-2 rounded-2xl">
				<Typography type="semibold-16" className="!text-black">
					Get started with Claim Magic
				</Typography>
				<Button
					label="Take the Tour"
					decoration="line-primary"
					size="fit"
					className="!py-1 !w-fit"
					onClick={onTakeTheTour}
				/>
			</li>
		)}
	</>
);
